import React, { useEffect } from "react";
import { Grid, Divider, ListItem, ListItemText, Drawer, Typography } from '@mui/material';
import Search from '@mui/icons-material/Search';

function DrawerDetails({ drawerValue }) {
    const [dataValue, setDataValue] = React.useState(drawerValue);

    useEffect(() => {
        setDataValue(drawerValue);
    }, [drawerValue]);

    return (
        <>
            <Grid container style={{ background: '#58A618', height: '5.5rem' }}>
                <a label="" style={{ fontSize: '16pt', color: 'white', margin: 'auto', fontWeight: 'bold' }}>Company Details <Search /></a>
            </Grid>
            <ListItem>
                <ListItemText>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={6}>Rating:</Grid>
                        {dataValue?.rating === 'B' &&
                            <Grid item xs={12} sm={12} md={6}><b style={{ color: '#58A618' }}>Positive Experience</b></Grid>
                        }
                        {dataValue?.rating === 'N' &&
                            <Grid item xs={12} sm={12} md={6}><b style={{ color: '#FF0000' }}>Negative Experience</b></Grid>
                        }
                        {dataValue?.rating === 'C' &&
                            <Grid item xs={12} sm={12} md={6}><b style={{ color: '#FFAB00' }}>Contact Us</b></Grid>
                        }
                    </Grid>
                </ListItemText>
            </ListItem>
            <Divider />
            <ListItem>
                <ListItemText>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={6}>Company Name:</Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <b>{dataValue?.company_name}</b>
                        </Grid>
                    </Grid>
                </ListItemText>
            </ListItem>
            <Divider />
            <ListItem>
                <ListItemText>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={6}>Phone:</Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <b>{dataValue?.phone}</b>
                        </Grid>
                    </Grid>
                </ListItemText>
            </ListItem>
            <Divider />
            <ListItem>
                <ListItemText>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={6}>MC:</Grid>
                        <Grid item xs={12} sm={12} md={6}><b>{dataValue?.mc}</b></Grid>
                    </Grid>
                </ListItemText>
            </ListItem>
            <Divider />
            <ListItem>
                <ListItemText>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={6}>DOT:</Grid>
                        <Grid item xs={12} sm={12} md={6}><b>{dataValue?.dot}</b></Grid>
                    </Grid>
                </ListItemText>
            </ListItem>
            <Divider />
            <ListItem>
                <ListItemText>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={6}>Address:</Grid>
                        <Grid item xs={12} sm={12} md={6}><b>{dataValue?.address}</b></Grid>
                    </Grid>
                </ListItemText>
            </ListItem>
            <Divider />
            <ListItem>
                <ListItemText>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={6}>City:</Grid>
                        <Grid item xs={12} sm={12} md={6}><b>{dataValue?.city}</b></Grid>
                    </Grid>
                </ListItemText>
            </ListItem>
            <Divider />
            <ListItem style={{ paddingBottom: '10rem' }}>
                <ListItemText>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={6}>State:</Grid>
                        <Grid item xs={12} sm={12} md={6}><b>{dataValue?.state}</b></Grid>
                    </Grid>
                </ListItemText>
            </ListItem>
            <Divider />
            <div style={{ position: 'fixed', 'bottom': '0px', padding: '1rem', background: '#4f4f4f' }}>
                <Typography color={'#fff'} textAlign={'center'}>
                    Email us at creditinquiry@tabbank.com for more information.
                </Typography>
            </div>
        </>
    )
}

export default DrawerDetails;